import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafePipe } from './safe.pipe';

@NgModule({
  imports: [CommonModule, SafePipe],
  exports: [SafePipe],
  providers: [SafePipe],
})
export class SafePipeModule {}
